import { createContext } from 'react'

import {
  DEFAULT_PRODUCT_TYPE,
  PRODUCT_TYPE,
} from '@lyrahealth-inc/shared-app-logic/src/features/common/constants/productType'

export const ProductTypeContext = createContext<{
  isLyraSelect: boolean
  isWellbeing?: boolean
  isBend?: boolean
  productType: PRODUCT_TYPE
  essentialsTheme?: string | null
  setEssentialsTheme?: (theme: string) => void
}>({
  isLyraSelect: false,
  isWellbeing: false,
  isBend: false,
  productType: DEFAULT_PRODUCT_TYPE,
  essentialsTheme: null,
  setEssentialsTheme: () => {},
})
